import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { GET_USER_BY_ID_QUERY_KEY } from './useGetUser';

export function useArchiveUser(userId: string) {
    const queryClient = useQueryClient();
    const apiClient = useApiClient();

    return useMutation({
        mutationFn: async () => {
            const response = await apiClient.fetchApi<{}, {}>({ method: 'POST', endpoint: `users/${userId}/archive` });
            return response;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: GET_USER_BY_ID_QUERY_KEY(userId) });
            queryClient.invalidateQueries({ queryKey: ['users'] });
        },
    });
}

export function useUnarchiveUser(userId: string) {
    const queryClient = useQueryClient();
    const apiClient = useApiClient();

    return useMutation({
        mutationFn: async () => {
            const response = await apiClient.fetchApi<{}, {}>({ method: 'POST', endpoint: `users/${userId}/unarchive` });
            return response;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: GET_USER_BY_ID_QUERY_KEY(userId) });
            queryClient.invalidateQueries({ queryKey: ['users'] });
        },
    });
}
